<template>
  <div class="terminal-app">
    <div class="w1200 pt96 pb48 center">
      <div class="lz-title1 mb8">App内嵌课堂</div>
      <div class="T6 EC3 mb64 lz-desc2">让每个APP都有一个课堂</div>
      <div class="lz-img">
        <img :src="require('@/assets/images/terminalPic13.jpg')" />
      </div>
    </div>
    <div class="w1200 pt64 pb8 modular-box">
      <div class="lz-title1 mb64">App内嵌课堂六大功能</div>
      <ul class="six-function">
        <li class="function-item center">
          <div class="icon">
            <i class="iconfont iconicon_account"></i>
          </div>
          <h3 class="name mb8 T5 EC2">账号打通</h3>
          <p class="EC2">知链与自有App联通</p>
        </li>

        <li class="function-item center">
          <div class="icon">
            <i class="iconfont iconicon_content"></i>
          </div>
          <h3 class="name mb8 T5 EC2">内容供应</h3>
          <p class="EC2">海量课程源供应</p>
        </li>

        <li class="function-item center">
          <div class="icon">
            <i class="iconfont iconicon_Live"></i>
          </div>
          <h3 class="name mb8 T5 EC2">直播授课</h3>
          <p class="EC2">五大直播功能支持</p>
        </li>

        <li class="function-item center">
          <div class="icon">
            <i class="iconfont iconicon_Recording"></i>
          </div>
          <h3 class="name mb8 T5 EC2">多样录播</h3>
          <p class="EC2">图文音视频全场景覆盖</p>
        </li>

        <li class="function-item center">
          <div class="icon">
            <i class="iconfont iconicon_Enrollment"></i>
          </div>
          <h3 class="name mb8 T5 EC2">招生获客</h3>
          <p class="EC2">丰富获客引流工具</p>
        </li>

        <li class="function-item center">
          <div class="icon">
            <i class="iconfont iconicon_Check"></i>
          </div>
          <h3 class="name mb8 T5 EC2">助学打卡</h3>
          <p class="EC2">完善课程服务体系</p>
        </li>
      </ul>
    </div>
    <div class="w1200 pt96 pb64 modular-box">
      <div class="lz-title1 mb64">
        更多能力，助您快人一步，<br
          v-if="$store.state.sceneClassName === 'app'"
        />立马拥有专属移动课堂
      </div>
      <ul class="capacity">
        <li class="function-item center">
          <div class="icon">
            <i class="EC1 T2 iconfont iconicon_skin"></i>
          </div>
          <h3 class="name mb8 T6 EC2">皮肤定制</h3>

          <p class="EC3 T7">保证整体展示风格统一</p>

          <p class="EC3 T7">提供良好的用户体验</p>
        </li>

        <li class="function-item center">
          <div class="icon">
            <i class="EC1 T2 iconfont iconicon_classroom1"></i>
          </div>
          <h3 class="name mb8 T6 EC2">课堂管理</h3>

          <p class="EC3 T7">上课信息自动提醒</p>

          <p class="EC3 T7">课件教务资料随时可查</p>
        </li>

        <li class="function-item center">
          <div class="icon">
            <i class="EC1 T2 iconfont iconicon_assistant"></i>
          </div>
          <h3 class="name mb8 T6 EC2">财务助手</h3>

          <p class="EC3 T7">详细记录每一笔流水</p>

          <p class="EC3 T7">图表展示营收清晰可见</p>
        </li>

        <li class="function-item center">
          <div class="icon">
            <i class="EC1 T2 iconfont iconicon_analysis"></i>
          </div>
          <h3 class="name mb8 T6 EC2">数据分析</h3>

          <p class="EC3 T7">沉淀学员人群画像</p>

          <p class="EC3 T7">数据化展示运营详细</p>
        </li>

        <li class="function-item center">
          <div class="icon">
            <i class="EC1 T2 iconfont iconicon_service"></i>
          </div>
          <h3 class="name mb8 T6 EC2">客服平台</h3>

          <p class="EC3 T7">专属客户经理实时在线</p>

          <p class="EC3 T7">答疑解惑一步到位</p>
        </li>

        <li class="function-item center">
          <div class="icon">
            <i class="EC1 T2 iconfont iconicon_Component"></i>
          </div>
          <h3 class="name mb8 T6 EC2">分享组件</h3>

          <p class="EC3 T7">免除跨系统登录步骤</p>

          <p class="EC3 T7">支持店铺、App数据同步</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'terminalApp',
  data() {
    return {};
  },
  components: {},
  mounted() {
  },
  methods: {

  }
};
</script>

<style lang="scss">
.terminal-app {
  .six-function {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .function-item {
      width: 368px;
      height: 260px;
      padding-top: 52px;
      margin-bottom: 54px;
      background: #fff;
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.06),
        0 20px 40px 0 rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      .iconfont {
        font-size: 64px;
        color: #1472ff;
      }
      .name {
        margin-top: 30px;
      }
    }
  }
}

.app .terminal-app {
  .modular-box:nth-child(even) {
    background: #f6f9ff;
  }
  .modular-box .lz-title1 {
    margin-bottom: 0;
  }
  .six-function {
    padding: 0.64rem 0.3rem 0;
    flex-wrap: wrap;
    .function-item {
      margin-bottom: 0.48rem;
      width: 48%;
      height: 3.68rem;
      box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.06);
      border-radius: 0.16rem;
      padding-top: 0.48rem;
      .icon {
        display: inline-block;
        width: 1.44rem;
        height: 1.44rem;
        line-height: 1.44rem;
        margin-bottom: 0;
        background: #266cff;
        border-radius: 50%;
        i {
          font-size: 0.84rem !important;
          color: #ffffff;
        }
      }
      h3 {
        margin-top: 0.22rem;
        font-size: 0.32rem;
        font-weight: 600;
        margin-bottom: 0;
      }
      p {
        margin-top: 0.16rem;

        font-size: 0.24rem;
      }
    }
  }
  .capacity {
    flex-wrap: wrap;
    padding: 0.64rem 0.3rem 0;
    .function-item {
      width: 50%;
      height: 3.68rem;
      padding-bottom: 0.48rem;
      .icon {
        display: inline-block;
        width: 1.2rem;
        height: 1.2rem;
        line-height: 1.2rem;
        background: #eaf4ff;
        border-radius: 50%;
        i {
          font-size: 0.58rem;
          color: #1472ff;
        }
      }
      .name {
        margin-top: 0.22rem;
        font-size: 0.32rem;
        font-weight: 600;
      }
      p {
        font-size: 0.24rem;
        color: #666;
        margin-top: 0.16rem;
      }
    }
  }
}
</style>
